(function(EF) {
  EF.services = EF.services || {};

  EF.services.assets = {
    filePaths: {},
    fileNameAliases: {},
    basePath: window.location.protocol + '//' + window.location.host,
    file: function(baseFolder, folderPath, fileName, extension) {
      return baseFolder + '/' + folderPath + '/' + EF.services.assets.fileNameAlias(fileName) + extension;
    },
    filePath: function(fileName) {
      return EF.services.assets.filePaths[fileName] ? EF.services.assets.filePaths[fileName] : EF.services.assets.activityPath();
    },
    fileNameAlias: function(fileName) {
      return EF.services.assets.fileNameAliases[fileName] ? EF.services.assets.fileNameAliases[fileName] : fileName;
    },
    activityPath: function() {
      return EF.module.get('key') + '/' + EF.module.currentActivity.get('key');
    },
    pageFile: function(baseFolder, fileName, extension) {
      return EF.services.assets.file(baseFolder, EF.services.assets.filePath(fileName), fileName, extension);
    },
    fileOverrides: function(pathOverrides, nameAliases) {
      EF.services.assets.filePaths = pathOverrides;
      EF.services.assets.fileNameAliases = nameAliases;
    }
  };

  var fileTypes = [
    { type: 'Script', extension: '.js' },
    { type: 'Css', extension: '.css' },
    { type: 'Template', extension: '.html' }
  ];

  function getPageTypeFileFunc(type) {
    return function(fileName) {
      // i.e. scriptFile
      return EF.services.assets[type + 'File'](EF.services.assets.filePath(fileName), fileName);
    };
  }

  function getTypeFileFunc(type, extension) {
    return function(folderPath, fileName) {
      // i.e. scriptFile
      return EF.services.assets.file(EF.options[type + 'Folder'], folderPath, fileName, extension);
    };
  }
  for(var i = 0; i < fileTypes.length; i++) {
    var type = fileTypes[i].type;
    var extension = fileTypes[i].extension;

    // i.e. pageScriptFile
    EF.services.assets['page' + type + 'File'] = getPageTypeFileFunc(type.toLowerCase());
    EF.services.assets[type.toLowerCase() + 'File'] = getTypeFileFunc(type.toLowerCase(), extension);
  }

})(window.EF);
